import { isPlatformServer } from '@angular/common';
import { Component, OnInit, Input,ViewChild, PLATFORM_ID, Inject, ElementRef, AfterViewInit } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { SearchService } from '../../services/search.service';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
//import { Router } from '@angular/router';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit,AfterViewInit {
  @Input() rendering: ComponentRendering;
  @Input() language: string;
  @ViewChild('HeroSlider', { static : false}) swiperSlider!: ElementRef;
  _isPlatformServer: boolean = false;
  swiper: Swiper;
  keyphrase: string;
  keyphrasePopular: string = " ";
  suggestions : any []= [];
  searchResults : any []= [];
  searchResultsPopular : any []= [];
  uuid : string;
  activeSuggestionIndex: number = -1;
  searchIsFocused : boolean;
  showMoreEnabled : boolean = false;
  noResultsFound : boolean = false;
  keyPhraseClear: boolean = false;
  isInitial: boolean = true;
  constructor(private el: ElementRef, @Inject(PLATFORM_ID) public readonly platformId: string, public searchService: SearchService) { }

  ngOnInit() {
    // remove this after implementation is done
    console.log('search component initialized with component data', this.rendering);

    this._isPlatformServer = isPlatformServer(this.platformId);
    if(!this._isPlatformServer){

      this.keyphrase = " ";
      this.searchPopular();

    }
  }
  ngAfterViewInit() {
    this.initSwiper();
  }

  initSwiper(){
    const searchSwiper = document.querySelector('#search-swiper');
    if (searchSwiper) {
      const timeRotation = parseFloat((this.rendering.fields?.TimeRotation as any)?.value);
      
      this.swiper = new Swiper(searchSwiper as HTMLElement, {
        slidesPerView: 4, // fallback/default
        slidesPerGroup: 4,
        autoplay: timeRotation && timeRotation > 0 ? {
          delay: timeRotation * 1000,
        } : false,
        speed: 1200,
        freeMode: false,
        centeredSlides: false,
        spaceBetween: 32,
        grabCursor: true,
        pagination: {
          el: "#search-swiper .swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          1024: { // lg screens and above (you can adjust the pixel value based on your design)
            slidesPerView: 4,
            slidesPerGroup: 4,
          }
        },
        modules: [Pagination, Autoplay],
      });
    }
    
  }
  
  onKeyphraseClear(event: Event) {
    const target = event.target as HTMLInputElement;
    this.keyPhraseClear = target.value === '';
    if (this.keyPhraseClear) {
      this.searchResults = [];
      this.noResultsFound = false;
      this.isInitial = true;  // back to initial-like state
      setTimeout(() => this.initSwiper(), 100);
    }
  }

  closeModal(): void {
    if (!this._isPlatformServer) {
        if (this.el) {
            // this.fadeOut(this.el.nativeElement.querySelector("#eq-search-modal"));
            // this.el.nativeElement.querySelector("#eq-search-modal").classList.remove("eq-movedown");
            // this.el.nativeElement.querySelector("#eq-search-modal").classList.add("eq-moveup");
            document.querySelector<HTMLElement>("body").classList.remove("eq-overflow-y-hidden");
            document.querySelector("#eq-search-modal").classList.add("eq-hidden");
        }
    }
}

fadeOut(element: HTMLElement) {
    if (!this._isPlatformServer) {
        let opacity = 1;
        let duration = 500;
        const interval = 16;
        const decrement = interval / duration;

        function tick() {
            opacity -= decrement;
            element.style.opacity = String(opacity);

            if (opacity <= 0) {
                element.style.display = "none";
                clearInterval(timer);
            }
        }

        const timer = setInterval(tick, interval);
    }
}

search(limit:number=8,offset:number=0){
    var searchRequest = {
        "content": {},
        "query": {
            "keyphrase": this.keyphrase
        },
        "limit":limit,
        "offset":offset
    };

    this.searchService.search(searchRequest, this.language).then(resp => {
        if (resp.status === 200) {
          this.noResultsFound = false;
          this.isInitial = false;
          if((resp.data as any)?.widgets[0]?.content?.length > 0){
            if((resp.data as any)?.widgets[0]?.content?.length < 8){
              this.showMoreEnabled = false;
            }
            this.suggestions = [];
            if(offset==0){
              this.searchResults = (resp.data as any)?.widgets[0]?.content?.map((results : any) => results);
              this.showMoreEnabled = (resp.data as any)?.widgets[0]?.content?.length < 8 ? false : true;
            }else{
              this.searchResults = this.searchResults.concat((resp.data as any)?.widgets[0]?.content?.map((results : any) => results));
            }
          }else{
            this.searchResults = [];
            this.showMoreEnabled = false;
            this.noResultsFound = true;
          }
        }
      });
}

searchPopular(limit:number=16,offset:number=0){
  var searchRequest = {
      "content": {},
      "query": {
          "keyphrase": this.keyphrasePopular
      },
      "limit":limit,
      "offset":offset
  };

  this.searchService.search(searchRequest, this.language).then(resp => {
      if (resp.status === 200) {
        this.noResultsFound = false;
        if((resp.data as any)?.widgets[0]?.content?.length > 0){
          if((resp.data as any)?.widgets[0]?.content?.length < 8){
            this.showMoreEnabled = false;
          }
          this.suggestions = [];
          if(offset==0){
            this.searchResultsPopular = (resp.data as any)?.widgets[0]?.content?.map((results : any) => results);
            this.showMoreEnabled = (resp.data as any)?.widgets[0]?.content?.length < 8 ? false : true;
          }else{
            this.searchResultsPopular = this.searchResultsPopular.concat((resp.data as any)?.widgets[0]?.content?.map((results : any) => results));
          }
        }else{
          this.searchResultsPopular = [];
          this.showMoreEnabled = false;
          this.noResultsFound = true;
        }
      }
    });
}

}
